import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CategoryTile = ({ category, index, large = false }) => {
  const [loaded, setLoaded] = useState(false);
  const img = useRef(null);
  const onMove = (e) => {
    const el = img.current; if (!el || window.matchMedia("(hover: none)").matches) return;
    const r = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `scale(1.12) translate(${(-x * 14).toFixed(1)}px, ${(-y * 14).toFixed(1)}px)`;
  };
  const onLeave = () => { if (img.current) img.current.style.transform = ""; };
  return (
    <Link to={`/categorie/${category.slug}`} data-testid={`home-category-${category.slug}`} onMouseMove={onMove} onMouseLeave={onLeave}
      className="bento-tile group relative block h-full rounded-2xl overflow-hidden border border-[#1E232D] hover:border-[#E01F1F]/60 transition-colors">
      {!loaded && <div className="absolute inset-0 shimmer" data-testid={`home-category-skeleton-${category.slug}`} />}
      <img ref={img} src={category.image} alt={category.name} loading={index < 4 ? "eager" : "lazy"} decoding="async" onLoad={() => setLoaded(true)} onError={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-700 ease-out ${loaded ? "opacity-80 group-hover:opacity-100" : "opacity-0"}`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#08090C] via-[#08090C]/50 to-transparent" />
      <div className="absolute top-4 left-4 font-display font-black italic text-white/15 text-3xl md:text-4xl group-hover:text-[#E01F1F]/50 transition-colors">{String(index + 1).padStart(2, "0")}</div>
      <div className="absolute bottom-0 inset-x-0 p-4 md:p-5 flex items-end justify-between gap-3">
        <span className={`font-display font-extrabold italic uppercase tracking-tight text-white leading-none translate-y-0 group-hover:-translate-y-1 transition-transform duration-300 ${large ? "text-3xl md:text-5xl" : "text-lg md:text-xl"}`}>{category.name}</span>
        <span className="w-9 h-9 shrink-0 rounded-full bg-white/10 backdrop-blur border border-white/15 flex items-center justify-center text-white group-hover:bg-[#E01F1F] group-hover:border-[#E01F1F] group-hover:rotate-45 transition-all duration-300"><ArrowUpRight size={18} /></span>
      </div>
    </Link>
  );
};

export const CategoryTileSkeleton = () => <div className="h-full rounded-2xl border border-[#1E232D] shimmer" data-testid="home-category-placeholder" />;

export default CategoryTile;
